"use strict";

document.addEventListener("DOMContentLoaded", () => {
  const getMarginLeft = () => {
    const firstItem = document.querySelector(".item");
    const style = window.getComputedStyle(firstItem);
    return parseFloat(style.marginLeft);
  };

  let adjustmentOffset;  // ここで変数を宣言

  const initializeHorizontalScroll = () => {
    adjustmentOffset = getMarginLeft();  // 初期化関数内で調整値を初期化
    const stickyContainers = document.querySelectorAll(".horizontal_scroll");
    stickyContainers.forEach((stickyContainer) => {
      const stickyItem = stickyContainer.querySelector(".sticky");
      const scroller = stickyContainer.querySelector(".scroller");
      scroller.classList.add("nobar");

      const updateStickyHeight = () => {
        const stickyHeight = scroller.scrollWidth - scroller.clientWidth + stickyItem.clientHeight;
        stickyContainer.style.setProperty("--sticky-container-height", `${stickyHeight}px`);
      };

      updateStickyHeight();

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateStickyHeight).observe(scroller);
        new ResizeObserver(updateStickyHeight).observe(stickyItem);
      } else {
        window.addEventListener('resize', updateStickyHeight);
      }

      const syncScroll = () => {
        const scrollY = window.scrollY;
        const offsetY = stickyContainer.offsetTop;
        if (scrollY < offsetY) {
          scroller.scrollLeft = 0;
        } else if (scrollY >= offsetY && scrollY <= (offsetY + (scroller.scrollWidth - scroller.clientWidth))) {
          scroller.scrollLeft = scrollY - offsetY;
        } else {
          scroller.scrollLeft = scroller.scrollWidth - scroller.clientWidth;
        }

        setActiveItem();
      };

      window.addEventListener("scroll", syncScroll, { passive: true });
    });
  };

  const setActiveItem = () => {
    const items = document.querySelectorAll(".item");
    const navLinks = document.querySelectorAll("nav a");
    const midashi = document.querySelector("h2.midashi");
    const midashiRect = midashi.getBoundingClientRect();
    const offsetThreshold = midashiRect.left - 200; // h2.midashiの位置から200px左

    let currentItem = null;
    let minOffset = Infinity;

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const offset = rect.left;

      if (offset >= offsetThreshold && offset < minOffset) {
        minOffset = offset;
        currentItem = item;
      }
    });

    items.forEach((item) => item.classList.remove("is-current"));
    navLinks.forEach((link) => link.classList.remove("is-current"));

    if (currentItem) {
      currentItem.classList.add("is-current");
      document.querySelector(`nav a[href="#${currentItem.id}"]`).classList.add("is-current");
    }
  };

  const scrollToElement = (targetElement) => {
    const horizontalScrollContainer = targetElement.closest(".horizontal_scroll");
    const verticalOffset = horizontalScrollContainer.offsetTop;
    const horizontalOffset = targetElement.offsetLeft;

    let targetScrollTop = verticalOffset + horizontalOffset - adjustmentOffset - 15;

    if (targetElement.previousElementSibling === null) {
      targetScrollTop = verticalOffset;
    }

    window.scrollTo({
      top: targetScrollTop,
      behavior: 'smooth'
    });

    setTimeout(() => {
      setActiveItem();
    }, 500);  // Smooth Scroll duration
  };

  let activeScroll = false;

  const checkAndInitialize = () => {
    if (window.innerWidth >= 769) {
      if (!activeScroll) {
        activeScroll = true;
        initializeHorizontalScroll();
      }
    } else {
      if (activeScroll) {
        activeScroll = false;
        window.removeEventListener("scroll", setActiveItem);
        // リサイズ観察のための cleanup
        if ('ResizeObserver' in window) {
          Array.from(document.querySelectorAll('.scroller, .sticky')).forEach(element => {
            ResizeObserver.unobserve(element);
          });
        } else {
          window.removeEventListener('resize', setActiveItem);
        }
      }
    }
  };

  checkAndInitialize();

  window.addEventListener("resize", checkAndInitialize);

  document.querySelectorAll("nav a").forEach((anchor) => {
    anchor.addEventListener("click", (event) => {
      if (window.innerWidth >= 769) {
        event.preventDefault();
        const targetId = anchor.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          scrollToElement(targetElement);
        }
      }
    });
  });
});

//

$('.scroller').find('.item').on('mouseenter', function () {
  $(this).find('.hover-deco').addClass('is-hover');
}).on('mouseleave', function () {
  $(this).find('.hover-deco').removeClass('is-hover');
});

//

document.addEventListener("DOMContentLoaded", function () {
  // YouTube IFrame Player APIを読み込み
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var players = [];
  var currentPlayer = null;

  window.onYouTubeIframeAPIReady = function () {
    var playerElements = document.querySelectorAll('.player');

    playerElements.forEach(function (playerElement, index) {
      var playerId = 'youtube-player-' + index;
      playerElement.id = playerId;

      var videoId = playerElement.getAttribute('data-video-id');
      var item = playerElement.closest('.item');

      var player = new YT.Player(playerId, {
        height: '100%',
        width: '100%',
        videoId: videoId,
        events: {
          'onStateChange': function (event) {
            onPlayerStateChange(event, item, player);
          }
        }
      });

      players.push(player);
    });
  };

  function onPlayerStateChange(event, item, player) {
    if (event.data == YT.PlayerState.PLAYING) {
      // 他のプレイヤーを一時停止
      if (currentPlayer && currentPlayer !== player) {
        currentPlayer.pauseVideo();
        var currentPlayerItem = document.getElementById(currentPlayer.getIframe().id).closest('.item');
        currentPlayerItem.classList.remove('is-play');
      }
      currentPlayer = player;
      item.classList.add('is-play');
    } else {
      if (currentPlayer === player) {
        item.classList.remove('is-play');
        currentPlayer = null;
      }
    }
  }
});
